<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="课程分类">
              <a-cascader
                allowClear
                changeOnSelect
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                :options="type"
                @change="treeChange"
                placeholder="请选择"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="课程名称">
              <a-input placeholder="请输入课程名称" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="12" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'选课报名-搜索'">搜索</a-button>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="24" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="searchList">搜索</a-button> -->
            <!-- <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button> -->
            <!-- <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
              {{ expand?"闭合":"高级搜索" }}
              <a-icon :type="expand ? 'up' : 'down'"/>
            </a>-->
          <!-- </a-col>
        </a-row> -->
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn
        name="添加"
        class="pxkeji_basic_btn"
        @click="showInfo(0,1)"
        type="primary"
      /> -->
      <pxkeji-btn name="批量导出" v-if="selectRows.length>0" class="pxkeji_basic_btn"  v-btnlimit="'选课报名-批量导出'" />
      <pxkeji-btn
        name="批量启用"
        :roles="['优惠券-启用禁用']"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        :roles="['优惠券-启用禁用']"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="count" slot-scope="count">
          <span v-if="count==-1">不限</span>
          <span v-else>{{count}}</span>
        </span>
        <span slot="state" slot-scope="state">
          <a-tag v-if="state==0" color="green">正常</a-tag>
          <a-tag v-else color="red">离职</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="报名"
            :roles="[]"
            v-btnlimit="'选课报名-报名'"
            @click="showInfo(action.id)"
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />
          <pxkeji-btn
            name="学员明细"
            :roles="[]"
            v-btnlimit="'选课报名-学员明细'"
            @click="handledetails(action.id)"
            size="small"
            type="primary"
          />
          <!--<pxkeji-btn
                  name="禁用"
                  @click="handleProhibit(action.userId,0)"
                  size="small"
                  type="dashed"
                  
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  @click="handleProhibit(action.userId,1)"
                  size="small"
                  type="dashed"
              
                  v-else
                /> -->
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      title="报名"
      v-model="addedit.visible"
      width="80%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :infos="addedit.info" />
    </a-modal>
    <a-modal
      title="学生明细"
      v-model="detail.visible"
      width="80%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <studentdetaillistInfo @callbackMethod="save" :id="detail.id" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./enroll_students.vue"; //报名学生列表
import studentdetaillistInfo from "./studentdetaillistInfo.vue"; //学生明细

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "编号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "课程名称"
  },
  {
    dataIndex: "typeName",
    key: "typeName",
    align: "center",
    title: "课程分类"
  },
  {
    dataIndex: "rootTypeName",
    key: "rootTypeName",
    align: "center",
    title: "课程类型"
  },
  {
    dataIndex: "classHour",
    key: "classHour",
    align: "center",
    title: "课时"
  },
  {
    dataIndex: "presentPrice",
    key: "presentPrice",
    align: "center",
    title: "价格/元"
  },
  {
    dataIndex: "buyCount",
    key: "buyCount",
    align: "center",
    title: "报名人数"
  },
  {
    dataIndex: "teacherName",
    key: "teacherName",
    align: "center",
    title: "讲师"
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "couponlist",
  data() {
    return {
      expand: false, //高级搜索
      type: [],
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      detail:{//学生明细
        visible:false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          typeId: "",
        
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    Info: Info,
    studentdetaillistInfo: studentdetaillistInfo
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
      this.GetCateList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetCateList() {
      //获取列表
      this.isloading = true;
      this.$api.courseType
        .getTreeByColumnId('', '')
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.type = res.data;
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
     treeChange(val) {
      this.where.keyword.typeId=val[val.length-1];
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.course
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.typeId,
          this.where.keyword.name,
          null,
          0,
          null,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id) {
      this.addedit.visible = true;
      this.addedit.id = id;
      console.log(id)
    },
    /**学生明细 */
    handledetails(id) {
      this.detail.visible = true;
      this.detail.id = id;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.operation.coupon
            .removeById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /**发券 */
    giveCoupon(id) {
      this.issuing.visible = true;
      this.issuing.id = id;
    },
    /**明细 */
    voidCoupon(id) {
      this.voids.visible = true;
      this.voids.id = id;
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

